// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
export function PlayerAvatar({
  player: u,
  className: o = "avatar"
}) {
  const m = u.firstName.trim().charAt(0).toUpperCase() || "M";
  return jsxRuntime.jsx("div", {
    className: o,
    children: u.photoUrl ? jsxRuntime.jsx("img", {
      src: u.photoUrl,
      alt: ""
    }) : m
  });
}
